// Imports
import styled from "styled-components"
import { Variables } from "fajny-react"

const SquareSpacer = styled.span`
    width: 100%;
    height: ${({ $height }) => $height}px;
    background-color: ${Variables.Colors.Danger100};
    display: block;
`

export default SquareSpacer
